(function () {
  'use strict';

  /* ==========================================================================
     PETAL Theme JavaScript
     ========================================================================== */

  /* ---------- Announcement Bar ---------- */
  var announcementSection = document.querySelector('.announcement-bar-section');
  var announcementBar = document.querySelector('.announcement-bar');
  var announcementClose = document.querySelector('.announcement-bar__close');

  function initAnnouncement() {
    if (!announcementSection) return;

    var dismissed = sessionStorage.getItem('petal-announcement-dismissed');
    if (dismissed === 'true') {
      announcementSection.classList.add('is-hidden');
    }

    if (announcementClose) {
      announcementClose.addEventListener('click', function () {
        announcementSection.classList.add('is-hidden');
        sessionStorage.setItem('petal-announcement-dismissed', 'true');
      });
    }
  }

  /* ---------- Header Scroll (box-shadow only, never hide) ---------- */
  function initHeaderScroll() {
    var header = document.querySelector('.section-header-wrapper');
    if (!header) return;

    var scrollThreshold = 50;

    function onScroll() {
      var currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile Menu ---------- */
  function initMobileMenu() {
    var toggle = document.querySelector('.mobile-menu-toggle');
    var menu = document.querySelector('.mobile-menu');
    var close = document.querySelector('.mobile-menu__close');
    var overlay = document.querySelector('.mobile-menu__overlay');

    if (!toggle || !menu) return;

    function openMenu() {
      menu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        var panel = menu.querySelector('.mobile-menu__panel');
        if (panel) panel.style.transform = 'translateX(0)';
      });
    }

    function closeMenu() {
      var panel = menu.querySelector('.mobile-menu__panel');
      if (panel) panel.style.transform = '';
      setTimeout(function () {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      }, 400);
    }

    toggle.addEventListener('click', openMenu);
    if (close) close.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }

  /* ---------- Quantity Selector ---------- */
  function initQuantitySelectors() {
    var selectors = document.querySelectorAll('.product-form__quantity, .cart-item__quantity');

    selectors.forEach(function (selector) {
      var minusBtn = selector.querySelector('[data-quantity-minus]');
      var plusBtn = selector.querySelector('[data-quantity-plus]');
      var input = selector.querySelector('input[type="number"]');

      if (!input) return;

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          if (val > 1) {
            input.value = val - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          var max = parseInt(input.getAttribute('max'), 10) || 9999;
          if (val < max) {
            input.value = val + 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    });
  }

  /* ---------- Collection Sort ---------- */
  function initCollectionSort() {
    var sortSelect = document.querySelector('.collection-sort-select');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Product Gallery ---------- */
  function initProductGallery() {
    var mainImage = document.querySelector('.product-gallery__main img');
    var thumbs = document.querySelectorAll('.product-gallery__thumb');

    if (!mainImage || thumbs.length === 0) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var newSrc = this.getAttribute('data-full-src') || this.querySelector('img').src;
        var newAlt = this.querySelector('img') ? this.querySelector('img').alt : '';

        mainImage.src = newSrc;
        mainImage.alt = newAlt;

        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
      });
    });
  }

  /* ---------- Variant Selector ---------- */
  function initVariantSelector() {
    var variantSelects = document.querySelectorAll('.product-form__variant-select select');
    var variantInput = document.querySelector('input[name="id"]');
    var variantJson = document.querySelector('[data-product-variants]');

    if (!variantSelects.length || !variantInput || !variantJson) return;

    var variants;
    try {
      variants = JSON.parse(variantJson.textContent);
    } catch (e) {
      return;
    }

    variantSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var selectedOptions = [];
        variantSelects.forEach(function (s) {
          selectedOptions.push(s.value);
        });

        var matched = variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === selectedOptions[i];
          });
        });

        if (matched) {
          variantInput.value = matched.id;

          var priceEl = document.querySelector('.product-info__price');
          if (priceEl && matched.price) {
            var formattedPrice = (matched.price / 100).toFixed(2);
            priceEl.innerHTML = '$' + formattedPrice;
          }

          var addBtn = document.querySelector('.product-form__submit');
          if (addBtn) {
            if (matched.available) {
              addBtn.disabled = false;
              addBtn.textContent = addBtn.getAttribute('data-add-text') || 'Add to Cart';
            } else {
              addBtn.disabled = true;
              addBtn.textContent = addBtn.getAttribute('data-sold-text') || 'Sold Out';
            }
          }
        }
      });
    });
  }

  /* ---------- Customer Login Toggle ---------- */
  function initLoginToggle() {
    var toggleLinks = document.querySelectorAll('[data-login-toggle]');
    var loginForm = document.getElementById('CustomerLoginForm');
    var recoverForm = document.getElementById('RecoverPasswordForm');

    if (!toggleLinks.length || !loginForm || !recoverForm) return;

    toggleLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        loginForm.classList.toggle('is-hidden');
        recoverForm.classList.toggle('is-hidden');
      });
    });

    if (window.location.hash === '#recover') {
      loginForm.classList.add('is-hidden');
      recoverForm.classList.remove('is-hidden');
    }
  }

  /* ---------- Smooth Scroll ---------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;

        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ---------- Address Form Toggle ---------- */
  function initAddressForm() {
    var toggleButtons = document.querySelectorAll('[data-address-toggle]');

    toggleButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = this.getAttribute('data-address-toggle');
        var target = document.getElementById(targetId);
        if (target) {
          target.classList.toggle('is-hidden');
        }
      });
    });
  }

  /* ---------- Initialize on DOM Ready ---------- */
  function init() {
    initAnnouncement();
    initHeaderScroll();
    initMobileMenu();
    initQuantitySelectors();
    initCollectionSort();
    initProductGallery();
    initVariantSelector();
    initLoginToggle();
    initSmoothScroll();
    initAddressForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
